import { useAdsContext, useLoadHeadScripts } from '@search/ads';
import { useEffect } from 'react';
import { useAppContext } from '../../contexts/AppContext';
const useContextUpdater = () => {
    const [searchModel, pageData] = useAppContext((store) => [store.searchModel, store.pageData]);
    const { updateAdsSearchModel, updateSearchModel } = useAdsContext();
    useEffect(() => {
        updateAdsSearchModel(pageData);
    }, [pageData]);
    useEffect(() => {
        if (searchModel)
            void updateSearchModel(searchModel);
    }, [searchModel]);
};
export const useAds = () => {
    useContextUpdater();
    useLoadHeadScripts();
};
